// Shared via layer pattern helpers
//
// Draws the cross (X) pattern on elements that reside on via layers.
// Used by both route.ts (route-inferred vias) and layout.ts (generator-placed vias).

import { graphics, Bbox } from "GenAlphaModel";
import { schema, pdk_utils } from "GenAlphaSchema";
import * as style from "../../style";
import { DrawTo } from "../../draw";

// Check whether a (decoded) layer number is a via layer according to the PDK.
export function isViaLayer(
  layerNumber: number,
  pdk: schema.pdk.PDK | null
): boolean {
  if (!pdk) return false;
  const pdkLayer = pdk_utils.findLayer(layerNumber, pdk);
  return pdkLayer?.category === "via";
}

// Draw a cross (X) inside the given bounding box.
// Uses stroke-only styling so the cross overlays without filling.
export function drawViaCross(to: DrawTo, bbox: Bbox, color: style.Color): void {
  const crossStyle: style.ShapeStyle = {
    fill: style.Special.None,
    stroke: color,
    linewidth: 1,
    cap: "round",
    join: "round",
  };

  // Diagonal from min corner to max corner
  to.path(
    graphics.Path.fromPartial({
      points: [bbox.min, bbox.max],
    }),
    crossStyle
  );

  // Diagonal from bottom-left to top-right
  to.path(
    graphics.Path.fromPartial({
      points: [
        { x: bbox.min.x, y: bbox.max.y },
        { x: bbox.max.x, y: bbox.min.y },
      ],
    }),
    crossStyle
  );
}
